import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";
import reqVenda from "../../../../services/reqMultiTenant/reqVenda";
import MainReportMatrix from "../../matrix";

const ReportRankingClientes = (props) => {
	const options = {
		title: "Ranking de Clientes",
		subTitle: "Top compradores por volume financeiro no período",
		ident: "rankingClientes",
		identFilter: "filterRankingClientes",
		identReport: "reportRankingClientes",
		tableColumns: [
			{ key: "tipo_cliente", label: "Tipo Cliente", align: "left" },
			{ key: "nome", label: "Cliente", align: "left" },
			{ key: "total_vendas", label: "Total Compras", align: "center" },
			{ key: "valor_total", label: "Valor Total", align: "center", format: "currency" },
		],
		reportColumns: [
			{ key: "tipo_cliente", label: "Tipo Cliente", align: "left" },
			{ key: "nome", label: "Cliente", align: "left" },
			{ key: "total_vendas", label: "Total Compras", align: "center" },
			{ key: "valor_total", label: "Valor Total", align: "right", format: "currency" },
		],

		showTime: true,
		hasActive: false,
		hasSaleType: true,
		hasClientType: true,
		parametersDate: [{ id: 1, label: "Data da venda", value: "dtVenda" }],
		hasParam: false,
		parametersFilter: [],
		listDataTotal: [{ key: "valor_total_geral", label: "Total GERAL do período", format: "currency" }],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };

		const response = await reqVenda.listRanking(newFilterData);

		return response;
	};

	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} FormFilter={FilterReportDateItens} />
		</div>
	);
};

export default ReportRankingClientes;
